
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertFpsApp (parameter) {
  return axios({
    url: sysInfo.apiFpsRemote + '/zm/app',
    method: 'POST',
    data: parameter
  })
}
export function updateFpsApp (parameter) {
  return axios({
    url: sysInfo.apiFpsRemote + '/zm/app',
    method: 'POST',
    data: parameter
  })
}
export function deleteFpsApp (parameter) {
  return axios({
    url: sysInfo.apiFpsRemote + '/zm/app',
    method: 'DELETE',
    params: parameter
  })
}
export function getFpsAppList (parameter) {
  return axios({
    url: sysInfo.apiFpsRemote + '/zm/apps',
    method: 'GET',
    params: parameter
  })
}
export function getFpsAppInfo (parameter) {
  return axios({
    url: sysInfo.apiFpsRemote + '/zm/app',
    method: 'GET',
    params: parameter
  })
}
